// Special dates to highlight in the calendar
export const specialDates = [
  {
    month: 2, // February
    day: 12,
    type: 'anniversary',
    label: 'Anniversary Day',
    icon: 'favorite', // Heart icon for anniversary
  },
  {
    month: 6, // June
    day: 12,
    type: 'propose',
    label: 'Propose Day',
    icon: 'diamond', // Diamond icon for propose
  },
  {
    month: 7, // July
    day: 15,
    type: 'birthday',
    label: "Serkan's Birthday",
    icon: 'cake', // Cake icon for birthday
    person: 'Serkan',
  },
  {
    month: 8, // August
    day: 1,
    type: 'birthday',
    label: "Umka's Birthday",
    icon: 'cake',
    person: 'Umka',
  },
  {
    month: 9, // September
    day: 17,
    type: 'birthday',
    label: "Sonya's Birthday",
    icon: 'cake',
    person: 'Sonya',
  },
  {
    month: 11, // November
    day: 18,
    type: 'birthday',
    label: "Sasha's Birthday",
    icon: 'cake',
    person: 'Sasha',
  },
];

/**
 * Get special date for a given month and day
 * @param {number} month - Month (1-12)
 * @param {number} day - Day (1-31)
 * @returns {Object|null} Special date object or null
 */
export const getSpecialDate = (month, day) => {
  return specialDates.find(date => date.month === month && date.day === day) || null;
};

/**
 * Check if a date is special
 * @param {number} month - Month (1-12)
 * @param {number} day - Day (1-31)
 * @returns {boolean}
 */
export const isSpecialDate = (month, day) => {
  return getSpecialDate(month, day) !== null;
};


